import React from "react"
import Helmet from "react-helmet"

const NoIndexHelmet = ({ title }) => {
  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
      {title && <title>{title}</title>}
    </Helmet>
  );
};

export default NoIndexHelmet;